<script>
import { authComputed } from "@/state/helpers";
import { required, decimal } from "vuelidate/lib/validators";
import VueDropify from "vue-dropify";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import errorHandler from "../helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import hkService from "@/helpers/APIService/hk.service";

/**
 * mini bar item Component
 */
export default {
  page: {
    title: "StaffForm",
  },
  components: {
    VueDropify,
    VueCropper,
  },
  data() {
    return {
      createError: false,
      errorMessage: "",
      item: {
        name: "",
        price: "",
        image: "",
      },
      imgURL: "",
      submitted: false,
      isBtnLoading: false,
      isSaveAndAddNew: false,
      isUniqueValue: false,
      uniqueValueMessage: {
        name: "",
      },
    };
  },
  computed: {
    ...authComputed,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  async mounted() {
    this.setIfEdit();
  },
  methods: {
    setIfEdit() {
      if (this.currentProps.isEdit) {
        hkService
          .getMiniBarItemDetails(this.currentProps.selectedItem.id)
          .then((response) => {
            this.item.name = response.name;
            this.item.price = response.price;
            this.item.image = response.image;
          });
      }
    },
    handleSubmit() {
      this.isUniqueValue = false;
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        this.item.price = parseFloat(this.item.price).toFixed(2);
        if (this.currentProps.isEdit) {
          this.currentProps.miniItemNameList.splice(
            this.item.name.toLowerCase()
          );
        }
        if (
          this.currentProps.miniItemNameList.includes(
            this.item.name.toLowerCase().trim()
          )
        ) {
          this.isUniqueValue = true;
          this.isBtnLoading = false;
          this.uniqueValueMessage.name = "name must be unique";
        } else {
          this.uniqueValueMessage.name = "";
        }
        if (!this.isUniqueValue) {
          let itemData = new FormData();
          if (this.item.image !== "") {
            if (typeof this.item.image !== "string") {
              itemData.append(
                "image",
                (this.item.image = this.createImageFromBase(
                  this.$refs.cropper.getCroppedCanvas().toDataURL(),
                  "image.jpg"
                ))
              );
            }
          } else {
            itemData.append("image", "");
          }
          itemData.append("name", this.item.name);
          itemData.append("price", this.item.price);
          itemData.append("hotel", this.hotel.id);
          if (this.currentProps.isEdit) {
            hkService
              .updateMiniBarItem(this.currentProps.selectedItem.id, itemData)
              .then(
                (response) => {
                  this.$emit("submitted", response);
                  this.isBtnLoading = false;
                  this.submitted = false;
                  this.errorMessage = "";
                  this.isUniqueValue = false;
                  this.uniqueValueMessage = {
                    name: "",
                  };
                },
                (error) => {
                  this.isBtnLoading = false;
                  this.createError = true;
                  if (error.response.status === 500) {
                    Middleware.notification(
                      "Internal server error !!",
                      "danger",
                      3000
                    );
                  } else {
                    if (
                      typeof error.response.data.non_field_errors == "object"
                    ) {
                      this.errorMessage = error.response.data.non_field_errors;
                    } else {
                      this.errorMessage = error.response.data;
                    }
                  }
                }
              )
              .catch((error) => {
                errorHandler(error);
              });
          } else {
            hkService
              .createMiniBarItem(itemData)
              .then((item) => {
                if (!this.isSaveAndAddNew) {
                  this.$emit("submitted", item);
                } else {
                  this.$emit("saveAndAddNew", item);
                  this.item = {
                    name: "",
                    price: "",
                    image: "",
                  };
                  this.imgURL = "";
                }
                this.isBtnLoading = false;
                this.submitted = false;
                this.errorMessage = "";
                this.isUniqueValue = false;
                this.uniqueValueMessage = {
                  name: "",
                };
              })
              .catch((error) => {
                this.isBtnLoading = false;
                this.createError = true;
                errorHandler(error);
                if (typeof error.response.data.non_field_errors == "object") {
                  this.errorMessage = error.response.data.non_field_errors;
                } else {
                  this.errorMessage = error.response.data;
                }
              });
          }
        }
      }
    },
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.handleSubmit();
    },
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    changeImage(event) {
      if (event[0] !== undefined) {
        this.item.image = event[0] == undefined ? null : event[0];
        this.imgURL = URL.createObjectURL(event[0]);
      } else {
        this.item.image = "";
        this.imgURL = "";
      }
    },
    createImageFromBase(dataUrl, filename) {
      var arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
  },
  validations: {
    item: {
      name: { required },
      price: { required, decimal },
    },
  },
};
</script>

<template>
  <div>
    <b-form ref="item-form">
      <div class="row">
        <div class="col-12">
          <b-card-title>
            <h4 class="card-title">
              {{ this.currentProps.isEdit ? "Update" : "Add" }} Mini Bar Item
            </h4>
            <h4 v-if="createError">
              <template v-if="typeof errorMessage == 'object'">
                <span v-for="error in errorMessage" :key="error">
                  <span class="badge card-badge badge-soft-danger">
                    <b>{{ error }}</b>
                  </span>
                  <br />
                </span>
              </template>
              <template v-else>
                <span class="badge card-badge badge-soft-danger">
                  <b>{{ errorMessage }}</b>
                </span>
              </template>
            </h4>
          </b-card-title>
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group class="mb-3" label-for="name-input">
            <span slot="label"> Name <span class="text-danger">*</span> </span>

            <b-form-input
              id="first-last-input"
              type="text"
              v-model="item.name"
              :class="{
                'is-invalid':
                  (submitted && $v.item.name.$error) ||
                  (isUniqueValue && uniqueValueMessage.name !== ''),
              }"
              autocomplete="off"
            ></b-form-input>
            <div
              v-if="submitted && $v.item.name.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.item.name.required">Name is required.</span>
            </div>
            <div v-if="isUniqueValue" class="invalid-feedback">
              <span v-if="uniqueValueMessage.name !== ''">{{
                uniqueValueMessage.name
              }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group class="mb-3" label-for="price-input">
            <span slot="label"> Price <span class="text-danger">*</span> </span>
            <b-form-input
              id="last-name-input"
              type="text"
              v-model="item.price"
              :class="{
                'is-invalid': submitted && $v.item.price.$error,
              }"
              autocomplete="off"
            ></b-form-input>
            <div
              v-if="submitted && $v.item.price.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.item.price.required">Price is required.</span>
              <span v-if="!$v.item.price.decimal"
                >Price accept only decimal number.</span
              >
            </div>
          </b-form-group>
        </div>

        <div class="col-md-12">
          <VueDropify
            v-if="imgURL == ''"
            @upload="changeImage($event)"
            :src="item.image ? item.image : ''"
            message="Drop image here or click to select"
          />
          <vue-cropper
            v-else
            ref="cropper"
            :src="imgURL"
            alt="Source Image"
            class="position-relative w-100 object-fit"
            :minCropBoxWidth="150"
            :minCropBoxHeight="150"
          >
          </vue-cropper>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-2">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="cancelSubmit"
            >Cancel</b-button
          >
          <b-button
            v-if="currentProps.isEdit === false"
            class="float-end ms-2"
            variant="outline-primary"
            type="button"
            @click="saveAndAddNew"
            :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
          >
            <i
              v-if="isSaveAndAddNew === true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i
            >Save & Add</b-button
          >
          <b-button
            class="float-end"
            variant="outline-primary"
            type="button"
            @click="handleSubmit"
            :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
          >
            <i
              v-if="isSaveAndAddNew !== true && isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            {{ currentProps.isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
